import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

axios.defaults.baseURL = 'http://localhost:8000/'
//axios.defaults.baseURL = 'https://x-svolis.gr'
//axios.defaults.baseURL = 'https://vickys-corner.xyz'

createApp(App).use(store).use(router).mount('#app')
